// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__2Rwn9","divider":"style_divider__2FAuk","tick":"style_tick__3PMe1","back-btn":"style_back-btn__2xbxf"};